<template>
    <div class="modal-window bds038">
        <header class="modal-header">
            <div class="tit">{{modalInfo.title || $i18nUtil.trans("title.BoardLinkProject.001", "과제 링크 내역")}}</div>
            <button @click="$emit('close')" class="btn_close">닫기</button>
        </header>
        
        <div class="modal-content">
            <div class="info-txt">{{ $i18nUtil.trans("message.BoardLinkProject.005","보드를 링크한 {project} 내역입니다.", {project: $i18nUtil.trans("entity.project","과제")}) }}</div>
            <div class="info-txt small">{{ $i18nUtil.trans("message.BoardLinkProject.006","링크추가 시 연결한 {project}에서 동일한 보드의 열람이 가능합니다.", {project: $i18nUtil.trans("entity.project","과제")}) }}</div>
            <div class="info-txt smaller">{{ $i18nUtil.trans("message.BoardLinkProject.007","* 단, [비공개][멤버만 공개]인 보드는 보드 멤버 외 다른 사람은 조회할 수 없습니다.") }}</div>

            <div class="task_link_box">
                <div class="task_link_add">
                    <button type="button" id="btn_link_add" class="btn_link_add" @click="$event.target.classList.toggle('active');">{{$i18nUtil.trans("message.BoardLinkProject.008","{project} 링크추가", {project: $i18nUtil.trans("entity.project","과제")})}}</button>
                    <div class="add_box">
                        <!-- <form action="" onsubmit="return false;">
                            <div class="search_ty1">
                                <input 
                                    type="text" 
                                    required 
                                    v-model="searchProjectName"
                                    placeholder="협업 멤버로 활동중인 명을 입력하세요."
                                    @input="searchProjectName = $event.target.value, filterProject(searchProjectName)"
                                    autocomplete="off"
                                />
                                <button type="reset" class="btn_search" @click="searchProjectName = '', clearAndFilterProject(searchProjectName, $event)">검색</button>
                                <div class="list scroll project-show" style="height: 100px" v-if="isProjectShow">
                                    <ul>
                                        <li 
                                            v-for="(projectItem, projectIndex) in projectListFilter"
                                            :value="projectItem"
                                            :key="projectItem.projectId + `test`+projectIndex"
                                            @click="changeProject(projectItem, $event)"
                                        >
                                            <button type="button">{{projectItem.projectName}}</button>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </form> -->

                        <div class="search_ty1">
                            <div class="dropdown ty2 wide relative">
                                <v-menu offset-y>
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-btn v-bind="attrs" class="ell-singleline" v-on="on">{{searchProjectName == "" ? $i18nUtil.trans("entity.project.search.select","과제 선택") : searchProjectName}}</v-btn>
                                    </template>
                                    <div class="dropdown-list">
                                        <div class="scroll">
                                            <div class="dropdown-list-item" v-if="projectListFilter == null || projectListFilter.length == 0">
                                                <div class="tit">
                                                    <button type="button" class="disabled">{{$i18nUtil.trans("message.BoardLinkProject.003","선택 가능한 과제가 없습니다.")}}</button>
                                                </div>
                                            </div>
                                            <div 
                                                v-else
                                                class="dropdown-list-item"
                                                v-for="(projectItem, projectIndex) in projectListFilter"
                                                :value="projectItem"
                                                :key="projectItem.projectId + `test`+projectIndex"
                                                @click="changeProject(projectItem, $event)"
                                            >
                                                <div class="tit">
                                                    <button type="button" class="ell-singleline"
                                                        @mouseover="mouseEvt(true, projectItem.projectName, $event)"
                                                        @mouseleave="mouseEvt(false, null, $event)"
                                                    >
                                                        {{ projectItem.projectName }}
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </v-menu>
                            </div>
                        </div>
                        
                        <div class="dropdown ty2 wide relative" :class="selectedProjectInfo == null ? 'disabled' : ''">
                            <v-menu offset-y>
                                <template v-slot:activator="{ on, attrs }">
                                    <v-btn v-bind="attrs" v-on="on" class="ell-singleline" :class="addLinkProjectCategoryName == '' ? 'disabled' : ''">
                                        {{addLinkProjectCategoryName == "" ? $i18nUtil.trans("entity.category.depth2.search.select","과정 선택") : addLinkProjectCategoryName}}
                                    </v-btn>
                                </template>
                                <div class="dropdown-list">
                                    <div class="scroll">
                                        <div class="dropdown-list-item" v-if="projectFolderList == null || projectFolderList.length == 0">
                                            <div class="tit">
                                                <button type="button" class="disabled">{{$i18nUtil.trans("message.BoardLinkProject.001","선택 가능한 과정이 없습니다.")}}</button>
                                            </div>
                                        </div>
                                        <div 
                                            v-else
                                            class="dropdown-list-item" 
                                            v-for="(projectFolderItem, projectFolderIndex) in projectFolderList"
                                            :value="projectFolderItem"
                                            :key="projectFolderIndex"
                                            @click="changeProjectFolder(projectFolderItem)"
                                        >
                                            <div class="tit">
                                            <button type="button" class="ell-singleline"
                                                @mouseover="mouseEvt(true, projectFolderItem.categoryName, $event)"
                                                @mouseleave="mouseEvt(false, null, $event)"
                                            >
                                                {{projectFolderItem.categoryName}}
                                            </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </v-menu>
                        </div>

                        <!-- <dl class="dropdown ty2 wide relative">
                            <dt id="dtProjectFolder">
                                <button 
                                    type="button" 
                                    :disabled="selectedProjectInfo == null || selectedProjectInfo == ''"
                                    @click="$event.target.parentElement.classList.toggle('active');"
                                >
                                    {{addLinkProjectCategoryName == "" ? ' 선택' : addLinkProjectCategoryName}}
                                </button>
                            </dt>
                            <dd>
                                <ul>
                                    <li 
                                        :value="{}"
                                        @click="changeProjectFolder(null, 'dtProjectFolder')"
                                    >
                                        <button type="button"> 선택</button>
                                    </li>
                                    <li
                                        v-for="(projectFolderItem, projectFolderIndex) in projectFolderList"
                                        :value="projectFolderItem"
                                        :key="projectFolderIndex"
                                        @click="changeProjectFolder(projectFolderItem, 'dtProjectFolder')"
                                    >
                                        <button type="button">
                                            {{ projectFolderItem.categoryName }}
                                        </button>
                                    </li>
                                </ul>
                            </dd>
                        </dl> -->
                        <div class="error" v-if="error">{{$i18nUtil.trans("message.BoardLinkProject.002","과정을 선택해주세요.")}}</div>
                        <div class="btn-box txtc">
                            <button type="button" class="btn-primary-small" @click="moreClose('btn_link_add')">{{ $i18nUtil.trans("button.cancel","취소") }}</button>
                            <button type="button" class="btn-primary-small black" @click="saveBoardLinkProject('btn_link_add')">{{ $i18nUtil.trans("button.link.add", "링크 추가") }}</button>
                        </div>
                    </div>
                </div>

                <div class="output">
                    <div class="subj3" v-html="$i18nUtil.trans('search.000','총 {cnt}건', {cnt: boardLinkProjectList == null ? 0 : boardLinkProjectList.length})"></div>
                    <div class="scroll">
                        <ul class="task_box" v-if="boardLinkProjectList != null && boardLinkProjectList.length > 0">
                            <li
                                v-for="(boardLinkProjectItem, boardLinkProjectIndex) in boardLinkProjectList"
                                :key="boardLinkProjectItem.paperProjectLinkId + '-index-' + boardLinkProjectIndex"
                                style="display:flex; padding: 0 75px 0 20px;"
                            >
                                <b class="ell-singleline" style="display: inline-block;">{{ boardLinkProjectItem.projectName }}</b>
                                <span class="ell-singleline" style="display: inline-block;">{{boardLinkProjectItem.categoryName}}</span>
                                <div class="btn_grp">
                                    <button type="button" 
                                        v-if="boardLinkProjectItem.regUserId == modalInfo.userInfo.userId || modalInfo.paperRegUserId == modalInfo.userInfo.userId || isRegUseFlag" 
                                        @click="deleteBoardLinkProject(boardLinkProjectItem)">{{ $i18nUtil.trans("button.terminateConn", "연결 해제") }}
                                    </button>
                                </div>
                            </li>
                        </ul>
                        <div class="nodata" v-else>{{$i18nUtil.trans("message.BoardLinkProject.004","연결된 과제가 없습니다.")}}</div>
                    </div>
                </div>

                <div class="tooltip-b tl small" :style="{'z-index': tooltip.zIndex, 'display': tooltip.display, 'bottom': tooltip.bottom, 'width': tooltip.width, 'left': tooltip.left}" style="position: absolute">
                    {{ tooltipCategoryName == null ? "" : tooltipCategoryName }}
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapActions } from "vuex";
import axios from "axios";

export default {
    components: {
    },
    props: {
      modalInfo: {
        type: Object,
        required: true,
      },
    },
    data() {
        return { 
            searchProjectName: "",
            isProjectShow: false,
            paperId: null,
            projectId: null,
            projectList: [],
            projectListFilter: [],
            selectedProjectInfo: null,
            addLinkProjectId: "",
            addLinkProjectGroupId: "",
            addLinkProjectCategoryMid: "",
            addLinkProjectCategoryName: "",
            projectFolderList: [],
            selectedProjectFolder: {},
            boardLinkProjectList: [],
            error: false,
            toastInfo: {
                obj: this.$toasted,
                message: "",
                options: {
                    theme: "toasted-primary",
                    position: "bottom-left",
                    duration: 3000,
                },
            },
            /* 보드 생성자 또는  */
            isRegUseFlag: false,

            /* 툴팁 */
            hover: false,
            tooltipFlag: false,
            tooltipCategoryName: null,
            tooltip: {
                zIndex: 0,
                display: 'none',
                bottom: '0px',
                width: '0px',
                left: '55px'
            }
        };
    },
    methods: { 
        ...mapActions("restAction", ["COWORK_REST_SIMPLE_ACTION", "COWORK_REST_ACTION"]),
        ...mapActions("modals", ["showToast", "showModal"]),

        mouseEvt(flag, categoryName, event) {
            this.hover = flag;
            this.tooltipCategoryName = categoryName
            // let val = this.$tooltip.checkTabLength(categoryName, 100)
            let val = this.$tooltip.hasOverflownModalSelectBox(event.target)
            this.tooltipFlag = this.hover == true && val == true ? true : false
            this.activateTooltip(this.tooltipFlag, event);
        },
        activateTooltip(val, event) {
            let modalStyle = document.getElementsByClassName("v--modal-box")[0].getBoundingClientRect(); // 모달의 style 정보;
            let loc = event.target.getBoundingClientRect().top; // 마우스 오버 타겟의 top
            loc = Math.abs(loc - modalStyle.bottom);
            
            let width = event.target.getBoundingClientRect().width;

            if(val) {
                this.tooltip.zIndex = 13;
                this.tooltip.display = "inline-block";
                this.tooltip.width = width+'px';
                this.tooltip.bottom = loc+'px';
            }else{
                this.tooltip.zIndex = 0;
                this.tooltip.display = "none";
                this.tooltip.width = '0px';
                this.tooltip.bottom = '0px';
            }
        },
        initProjectList() {
            let obj = this;
            let projectUrl = "/api/cogroup/project/getMyProjectList";
            let param = {};
            obj.showLoadingbar();
            axios
                .post(projectUrl, param)
                .then((res) => {
                    obj.hideLoadingbar();
                    if (res.data.errorCode != null && res.data.errorCode != undefined) {
                        console.log('getMyProjectList error', res.data.errorCode);
                        // return;
                    }
                    obj.projectList = res.data.result.data;
                    obj.selectedProjectInfo = null;
                    // 리스트 필터
                    obj.setProjectFilter();
                    obj.getBoardLinkProjectList();
                })
                .catch((err) => {
                    obj.hideLoadingbar();
                    console.log("axios err => ", err);
                });
        },
        getBoardLinkProjectList() {
            let obj = this;
            let projectUrl = "/api/copaper/paperlink/getBoardLinkProjectList";
            let param = {paperId: obj.paperId};
            obj.showLoadingbar();
            axios
                .post(projectUrl, param)
                .then((res) => {
                    obj.hideLoadingbar();
                    if (res.data.errorCode != null && res.data.errorCode != undefined) {
                        console.log('getBoardLinkProjectList error', res.errorCode);
                        // return;
                    }
                    obj.boardLinkProjectList = res.data.result;
                    obj.getMemberlist(obj.modalInfo.groupId);
                    obj.$emit("closeBoardLinkProjectModal", obj.boardLinkProjectList == null ? 0 : obj.boardLinkProjectList.length);
                })
                .catch((err) => {
                    console.log("axios err => ", err);
                });
        },
        getMemberlist(groupId) {
        let obj = this;
        let reqData = {};
        reqData.req = {
            groupId: groupId,
        };
        reqData.url = "/api/cogroup/cogroupUser/getCogroupUserList";
        reqData.method = "post";
        obj
            .COWORK_REST_ACTION(reqData)
            .then((res) => {
                console.log(res);
                if (res.errorCode) {
                    console.log(res.errorCode);
                } else {
                    let groupUserGrade = res.result.grade;
                    if(groupUserGrade != null && groupUserGrade != 'MEMBER') {
                        obj.isRegUseFlag = true;
                    }
                }
            })
            .catch(function (err) {
                console.log(err);
            });
        },
        moreClose(targetId) {
            if(document.getElementById(targetId).classList.contains("active")) {
                document.getElementById(targetId).classList.toggle("active");
            }
        },
        clearAndFilterProject() {
            let obj = this;
            obj.searchProjectName = "";
            obj.filterProject(obj.searchProjectName);
            obj.isProjectShow = false;
            obj.selectedProjectInfo = null;
            // obj.changeProject(null);
        },
        filterProject(searchProjectName) {
            let obj = this;
            if(obj.searchProjectName == '') {
                obj.changeProject(null);
            } else {
                obj.isProjectShow = true;
                obj.setProjectFilter();
            }
        },
        setProjectFilter() {
            let obj = this;
            if(obj.searchProjectName != null && obj.searchProjectName.length > 0) {
                const result = obj.projectList.filter(function(projectObj){ 
                    return projectObj.projectName.toLowerCase().indexOf(obj.searchProjectName.toLowerCase()) > -1;
                }); 
                obj.projectListFilter = result;
            } else {
                obj.projectListFilter = obj.projectList;
            }
        },
        changeProject(projectInfo) {
            let obj = this;
            obj.isProjectShow = false;
            obj.selectedProjectInfo = projectInfo;
            if(projectInfo != null && projectInfo.projectId != null && projectInfo.projectId != undefined) {
                obj.addLinkProjectId = null;
                obj.addLinkProjectGroupId = null;
                obj.addLinkProjectCategoryMid = null;
                obj.addLinkProjectCategoryName = "";
                obj.searchProjectName = projectInfo.projectName;
                let projectFolderUrl = "/api/copaper/category/getCategoryItemList";
                let param = {
                    categoryMid: null,
                    groupId: projectInfo.groupId,
                    type: "PROJECT"
                };
                obj.showLoadingbar();
                axios
                    .post(projectFolderUrl, param)
                    .then((res) => {
                        obj.hideLoadingbar();
                        if (res.data.errorCode != null && res.data.errorCode != undefined) {
                            console.log('getCategoryItemList error', res.data.errorCode);
                            // return;
                        }
                        obj.projectFolderList = res.data.result;
                    })
                    .catch((err) => {
                        obj.hideLoadingbar();
                        console.log("axios err => ", err);
                    });
            } else {
                obj.addLinkProjectId = null;
                obj.addLinkProjectGroupId = null;
                obj.addLinkProjectCategoryMid = null;
                obj.addLinkProjectCategoryName = "";
                obj.projectFolderList = [];
            }
        },
        changeProjectFolder(projectFolderInfo) {
            if(projectFolderInfo == null) {
                this.addLinkProjectId = null;
                this.addLinkProjectGroupId = null;
                this.addLinkProjectCategoryMid = null;
                this.addLinkProjectCategoryName = "";
            } else {
                this.addLinkProjectId = projectFolderInfo.projectId;
                this.addLinkProjectGroupId = projectFolderInfo.groupId;
                this.addLinkProjectCategoryMid = projectFolderInfo.categoryMid;
                this.addLinkProjectCategoryName = projectFolderInfo.categoryName;
                this.error = false;
            }
        },
        saveBoardLinkProject(dtId) {
            let obj = this;
            if(obj.addLinkProjectId == null || obj.addLinkProjectId == '' || obj.addLinkProjectCategoryMid == null || obj.addLinkProjectCategoryMid == '') {
                obj.error = true;
                return;
            }
            let saveUrl = "/api/copaper/paperlink/saveBoardLinkProject";
            let param = {
                paperId: obj.paperId,
                projectId: obj.addLinkProjectId,
                groupId: obj.addLinkProjectGroupId,
                categoryMid: obj.addLinkProjectCategoryMid,
            };
            obj.showLoadingbar();
            axios
                .post(saveUrl, param)
                .then((res) => {
                    obj.hideLoadingbar();
                    if (res.data.errorCode != null && res.data.errorCode != undefined) {
                        if(res.data.errorCode == "SAVE_FAIL_ALREADY_EXISTS") {
                            // 이미 등록된 링크입니다.
                            obj.toastInfo.message = obj.$i18nUtil.trans("TB089", "이미 등록된 링크입니다.");
                        }
                        else if(res.data.errorCode == "SAVE_FAIL_PAPER_CATEGORY_MID_REQUIRED") {
                            obj.toastInfo.message = obj.$i18nUtil.trans("TB089.001", "해당 보드는 과정이 없는 보드입니다.");
                        }
                        else if(res.data.errorCode == "SAVE_FAIL_SAME_CATEGORY_MID") {
                            obj.toastInfo.message = obj.$i18nUtil.trans("TB089.002", "해당 보드와 같은 과정에 링크 할 수 없습니다.");
                        }
                        obj.showToast(obj.toastInfo);
                        return;
                    }
                    obj.moreClose(dtId);
                    obj.addLinkProjectId = null;
                    obj.addLinkProjectGroupId = null;
                    obj.addLinkProjectCategoryMid = null;
                    obj.addLinkProjectCategoryName = "";
                    obj.selectedProjectInfo = null;
                    obj.searchProjectName = "";
                    obj.getBoardLinkProjectList();
                })
                .catch((err) => {
                    obj.hideLoadingbar();
                    console.log("axios err => ", err);
                });
        },
        deleteBoardLinkProject(item) {
            let obj = this;
            // Linked 보드 연결을 해제하시겠습니까?
            obj.showConfirmDialogWithJSON({
                confirmMessage: obj.$i18nUtil.trans('AB068', 'Linked 보드 연결을 해제하시겠습니까?'),
                confirmBtnText: obj.$i18nUtil.trans('button.dialog.unlink', '해제'),
                confirmBtnCallback: obj.deleteBoardLinkProjectApiCall,
                modalParam: {item: item},
            });
            
        },
        deleteBoardLinkProjectApiCall(callbackData) {
            let obj = this;
            let saveUrl = "/api/copaper/paperlink/saveBoardLinkProject";
            let param = {
                paperProjectLinkId: callbackData.modalParam.item.paperProjectLinkId,
                paperId: callbackData.modalParam.item.paperId,
                projectId: callbackData.modalParam.item.projectId,
                groupId: callbackData.modalParam.item.groupId,
                categoryMid: callbackData.modalParam.item.categoryMid,
            };
            obj.showLoadingbar();
            axios
                .post(saveUrl, param)
                .then((res) => {
                    obj.hideLoadingbar();
                    if (res.data.errorCode != null && res.data.errorCode != undefined) {
                        console.log('saveBoardLinkProject error', res.data.errorCode);
                        return;
                    }
                    obj.toastInfo.message = obj.$i18nUtil.trans('TB081', '연결이 해제되었습니다.'); //  "연결이 해제되었습니다.";
                    obj.showToast(obj.toastInfo);
                    obj.getBoardLinkProjectList();
                })
                .catch((err) => {
                    obj.hideLoadingbar();
                    console.log("axios err => ", err);
                });
        }
    },
    mounted() {
        this.paperId = this.modalInfo.paperId;
        // const self = this;
        // $("html").click(function (e) {
        //     if (!$(e.target).hasClass("project-show")) {
        //         self.isProjectShow = false;
        //     }
        // });
        this.initProjectList();
    },
}
</script>
<style scoped>
    .tooltip-b.tl::before, .tooltip-w.tl::before {
        top: auto;
        bottom: -6px;
        -webkit-transform: rotate(
            180deg
        );
        transform: rotate(
            180deg
        );
    }
    .bds038 .tab-content .dropdown.ty2 .dropdown-list > .scroll > div:nth-child(2) > .tit > .tooltip-b::before {
        top: auto; bottom: -8px;
        transform: rotate(180deg);
    }
    /* .task_link_box .output .task_box li {
        position: relative;
        display: flex;
        height: 40px; line-height: 40px; padding:0 65px 0 20px;
        border-radius: 8px;
        background-color: #f6f7fa;
    }
    .task_link_box .output .task_box li .ell-singleline { display: inline-block; }  */
</style>


// WEBPACK FOOTER //
// src/components/cowork/general/board/modal/BoardLinkProject.vue